import httpClient from "./httpClient";
import { Booking, BookingDetial } from "../types/bookings";

const bookings = {
	fetch: async (): Promise<BookingDetial[] | undefined> => {
		const response = await httpClient.get(`/bookings`);
		return response.data as BookingDetial[];
	}
};

const booking = {
	get: async (id: number): Promise<Booking | undefined> => {
		const response = await httpClient.get(`/bookings/${id}`);
		return response.data as Booking;
	},
	update: async (booking: Booking): Promise<Booking | undefined> => {
		const { id } = booking;
		const response = await httpClient.put(`/bookinglistings/${id}`, booking);
		return response.data as Booking;
	},
	accept: async (booking: Booking): Promise<Booking | undefined> => {
		const { id } = booking;
		const response = await httpClient.post(
			`/bookinglistings/${id}/accept`,
			booking
		);
		return response.data as Booking;
	},
	cancel: async (booking: Booking): Promise<Booking | undefined> => {
		const { id } = booking;
		const response = await httpClient.post(
			`/bookinglistings/${id}/cancel`,
			booking
		);
		return response.data as Booking;
	},
	confirm: async (booking: Booking): Promise<Booking | undefined> => {
		const { id } = booking;
		const response = await httpClient.post(
			`/bookinglistings/${id}/confirm`,
			booking
		);
		return response.data as Booking;
	},
	decline: async (booking: Booking): Promise<Booking | undefined> => {
		const { id } = booking;
		const response = await httpClient.post(
			`/bookinglistings/${id}/decline`,
			booking
		);
		return response.data as Booking;
	}
};

const bookinglistings = {
	fetch: async (): Promise<Booking[] | undefined> => {
		const response = await httpClient.get(`/bookinglistings`);
		return response.data as Booking[];
	},
	get: async (id: number): Promise<Booking | undefined> => {
		const response = await httpClient.get(`/bookinglistings/${id}`);
		return response.data as Booking;
	}
};

const responseTimes = {
	sitetour: async (id: number): Promise<Booking | undefined> => {
		const response = await httpClient.get(
			`/bookings/users/${id}/responsetime/site-tour`
		);
		return response.data as Booking;
	},
	callout: async (id: number): Promise<Booking | undefined> => {
		const response = await httpClient.get(
			`/bookings/users/${id}/responsetime/callout`
		);
		return response.data as Booking;
	}
};

export { bookings, bookinglistings, booking, responseTimes };
